import { createRoute, redirect } from '@tanstack/react-router'
import { rootRoute } from './__root'
import { WorkspaceHeader } from '@/components/WorkspaceHeader'
import { apiClient } from '@/lib/api'
import { usePlatform } from '@/hooks/usePlatform'
import { AutomationLaneView } from '@/components/werkshop/AutomationLane'

/**
 * Full-screen Automation Lane editor. Mirrors the inline
 * Automation tab on the Sequencer against the full viewport for
 * heavy envelope / automation work.
 */
export const werkshopAutomationToolRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/werkshop/tools/automation',
  beforeLoad: async () => {
    try {
      await apiClient.get('/api/v1/auth/me')
    } catch {
      throw redirect({ to: '/login' })
    }
  },
  component: AutomationTool,
})

function AutomationTool() {
  const platform = usePlatform()
  return (
    <div className="min-h-[100dvh] bg-surface-base flex flex-col">
      <WorkspaceHeader title="Automation" workspaceSwitcher="werkshop" />
      <main
        className={
          platform.isNative
            ? 'w-full px-3 sm:px-4 py-4 flex-1 flex flex-col gap-3'
            : 'w-full px-4 sm:px-6 py-6 flex-1 flex flex-col gap-4'
        }
      >
        <AutomationLaneView fullScreen />
      </main>
    </div>
  )
}
